import { IComponentStatus } from "../extra10outlets/types";

export const GET_X10_DEVICES = "x10devices/GET_X10_DEVICES";
export const GET_X10_DEVICES_SUCCESS = "x10devices/GET_X10_DEVICES_SUCCESS";
export const GET_X10_DEVICES_ERROR = "x10devices/GET_X10_DEVICES_ERROR";

export type X10DeviceSort = "OUTLET" | "NAME" | "LAST_HEARD";

/** What the device list asks jcore for. `locationName` is only for the outlet filter chip. */
export interface IX10DeviceQuery {
  search: string;
  live: boolean;
  locationId: string | null;
  locationName: string | null;
  /** 0-based, as jcore expects. */
  page: number;
  size: number;
  sort: X10DeviceSort;
}

export interface IX10DeviceOutlet {
  id: string;
  name: string;
  /** location.is_x10: whether the outlet is also in the Extra 10 outlet list. */
  x10Location: boolean;
  countryCode: string | null;
  countryName: string | null;
  distributorName: string | null;
  /** Machines installed at the outlet, whatever the list filters. */
  machines: number;
  liveMachines: number;
}

export interface IX10Device {
  id: string;
  name: string | null;
  boardSerialNumber: string | null;
  thingId: string | null;
  firmware: string | null;
  lastHeardAt: string | null;
  alive: boolean;
  status: IComponentStatus[];
  /** mL; null without an active keg. */
  volumeLeft: number | null;
  kegVolume: number | null;
  beverageId: string | null;
  outlet: IX10DeviceOutlet;
}

export interface IX10DevicePage {
  content: IX10Device[];
  page: number;
  size: number;
  totalElements: number;
}

export interface IX10DevicesState {
  query: IX10DeviceQuery;
  result: IX10DevicePage | null;
  loading: boolean;
  error: boolean;
}

export interface IGetX10DevicesAction {
  type: typeof GET_X10_DEVICES;
  payload: Partial<IX10DeviceQuery>;
}

export interface IGetX10DevicesSuccessAction {
  type: typeof GET_X10_DEVICES_SUCCESS;
  payload: IX10DevicePage;
}

export interface IGetX10DevicesErrorAction {
  type: typeof GET_X10_DEVICES_ERROR;
}

export type X10DevicesActionTypes =
  | IGetX10DevicesAction
  | IGetX10DevicesSuccessAction
  | IGetX10DevicesErrorAction;
